import React from "react";
import '../styles/base.scss'

const Layout = ({children}) => {
    return (
        <main>
            {children}
        </main>
    )

};

export default Layout;